import React from 'react';
// images
import Image from '../assets/jamil3.JPEG';
import ResumePDF from '../assets/Jamil Jalal - Cloud Engineering Manager - Resume.pdf';
// icons
import { FaGithub, FaLinkedin, FaDribbble } from 'react-icons/fa';
// type animation
import { TypeAnimation } from 'react-type-animation';
// motion
import { motion } from 'framer-motion';
// variants
import { fadeIn } from '../variants';

const Banner = () => {
  return (
    <section
      className='min-h-[85vh] lg:min-h-[78vh] flex items-center'
      id='home'
    >
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>
          {/* text */}
          <div className='flex-1 text-center font-secondary lg:text-left'>
            <motion.h1
              variants={fadeIn('up', 0.3)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='text-[55px] font-bold leading-[0.8] lg:text-[110px]'
            >
              Jamil <span>Jalal</span>
            </motion.h1>
            <motion.div
              variants={fadeIn('up', 0.4)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]'
            >
              <span className='text-white mr-4'>I am</span>
              <TypeAnimation
                sequence={[
                  'a Developer',
                  2000,
                  'a DevOps Engineer',
                  2000,
                  'an AI Engineer',
                  2000,
                ]}
                speed={50}
                className='text-accent'
                wrapper='span'
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn('up', 0.5)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='mb-8 max-w-lg mx-auto lg:mx-0'
            >
              I love automating infrastructure, wrangling data, and 
              turning machine learning models into real-world tools. 
              Whether it's streamlining deployments or experimenting with new AI ideas,
              I’m all about making tech work better (and a little more effortlessly).
              Always learning, always tinkering.
            </motion.p>
            <motion.div
              variants={fadeIn('up', 0.6)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0'
            >
              <a href="https://calendly.com/jamiljalal7794/30min" target="_blank" rel="noopener noreferrer">
                <button className='btn btn-lg'>Contact me</button>
              </a>
              <a href={ResumePDF} target="_blank" rel="noopener noreferrer" className='text-gradient btn-link'>
                My Resume
              </a>
            </motion.div>
            {/* socials */}
            <motion.div
              variants={fadeIn('up', 0.7)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0'
            >
              <a href='https://www.linkedin.com/in/jamil-jalal-61a788169/'>
                <FaLinkedin />
              </a>
              <a href='https://github.com/jamil7794'>
                <FaGithub />
              </a>
              {/* <a href='#'>
                <FaDribbble />
              </a> */}
            </motion.div>
          </div>
          {/* image */}
          <motion.div
            variants={fadeIn('down', 0.5)}
            initial='hidden'
            whileInView={'show'}
            className='flex flex-1 justify-center max-w-[320px] mx-auto lg:max-w-[482px] lg:mx-0 lg:justify-start'
          >
            <div className='relative h-[320px] w-[260px] sm:h-[400px] sm:w-[320px] lg:h-[500px] lg:w-[400px]'>
              <img src={Image} alt='' className='rounded-t-full rounded-tr-full rounded-br-full rounded-bl-none h-[320px] w-[260px] sm:h-[400px] sm:w-[320px] lg:h-[500px] lg:w-[400px] object-cover' />
              <div className='absolute top-0 left-0 w-full h-full rounded-t-full rounded-tr-full rounded-br-full rounded-bl-none bg-blue-500 opacity-20 pointer-events-none'></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
